import type { TicketStatus } from "./tickets";

export const legacyOpenTicketDbStatuses = ["open", "pending", "inProgress"] as const;

const legacyOpenTicketDbStatusSet = new Set<string>(legacyOpenTicketDbStatuses);

export function isLegacyOpenTicketDbStatus(status: string): boolean {
  return legacyOpenTicketDbStatusSet.has(status);
}

export function expandTicketStatusFilterForDb(statuses: TicketStatus[]): string[] {
  const expanded = new Set<string>();
  for (const status of statuses) {
    if (status === "open") {
      for (const openStatus of legacyOpenTicketDbStatuses) {
        expanded.add(openStatus);
      }
      continue;
    }
    expanded.add(status);
  }
  return [...expanded];
}
